import React, { useEffect, useState } from "react";
import Button from "../Elements/Button";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import {toast, ToastContainer} from "react-toastify";
import {useNavigate} from "react-router-dom";

const UserData = ({ id }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // Fetch user info on load / when id changes
    useEffect(() => {
        if (!id) return;

        let cancelled = false;
        setLoading(true);

        axios
            .post(`${API_BASE_URL}/get_user_infos_by_id`, { user: id })
            .then((res) => {
                if (cancelled) return;
                const data = res.data?.[0] ?? null;
                setUser(data);
            })
            .catch((err) => {
                console.error("Erreur lors du chargement de l'utilisateur", err);
            })
            .finally(() => !cancelled && setLoading(false));

        return () => {
            cancelled = true;
        };
    }, [id]);

    const handleResetPassword = () => {
        if (!user) return;
        const ok = window.confirm(
            `Voulez-vous envoyer un lien de réinitialisation par mail à l'adresse ${user.email} ?`
        );
        if (ok) {
            axios
                .post(`${API_BASE_URL}/reset_user_password`, { user_id: id, user_email: user.email })
                .then(() => {})
                .catch((err) => {
                    console.error("Erreur reset password:", err);
                });
        }
    };

    const handleDeleteUser = () => {
        if (!user) return;
        console.log("Suppression user:", user.id);
        const ok = window.confirm(
            `Voulez-vous vraiment supprimer le compte de ${user.email} ?`
        );
        if (ok) {
            axios
                .post(`${API_BASE_URL}/lock_user_account`, { user_id: user.id })
                .then(() => {
                    toast.success("Utilisateur supprimé avec succès.")
                })
                .catch((err) => {
                    console.error("Erreur suppression user:", err);
                });
        }
    };

    // Derive safe fields for rendering
    const username = user?.username || "sd"; // fallback to default avatar
    const firstname = user?.firstname || "";
    const lastname = user?.lastname || "";
    const role = user?.role_name || user?.role || "";
    const email = user?.email || "";

    return (
        <div>
            <ToastContainer position="bottom-right" autoClose={3000} />

            <div className={"display-flex mt-20 justify-content-space-between"}>
                <div className={"display-flex justify-content-start pb-10"}>
                    <Button
                        iconBackground={"bg-fifth"}
                        onClick={()=>navigate('/utilisateurs')}
                        icon={"fa-chevron-left"}
                        label={"Retour"}
                        textClassNames={
                            "Réinitialiser le mot de passe" === "Enregistré !"
                                ? "bg-primary"
                                : "bg-third btn-save"
                        }
                        iconClasseNames={"color-white"}
                        disableLink
                        disabled={!user || loading}
                    />
                </div>
                <div className={"display-flex justify-content-end gap-10 pb-10"}>
                    <Button
                        iconBackground={"bg-fifth"}
                        onClick={handleResetPassword}
                        icon={"fa-paper-plane"}
                        label={"Réinitialiser le mot de passe"}
                        textClassNames={
                            "Réinitialiser le mot de passe" === "Enregistré !"
                                ? "bg-primary"
                                : "bg-third btn-save"
                        }
                        iconClasseNames={"color-white"}
                        disableLink
                        disabled={!user || loading}
                    />

                    <Button
                        iconBackground={"bg-orangered"}
                        onClick={handleDeleteUser}
                        icon={"fa-xmark"}
                        label={"Supprimer le compte"}
                        textClassNames={
                            "Supprimer le compte" === "Supprimé !"
                                ? "bg-primary"
                                : "bg-orangered btn-save"
                        }
                        iconClasseNames={"color-white"}
                        disableLink
                        disabled={!user || loading}
                    />
                </div>
            </div>

            <div className={"display-flex flex-direction-column gap-20"}>
                <div
                    className={`container display-flex justify-content-space-between p-0 bg-white flex-direction-column img`}
                    style={{ height: 400 }}
                >
                    <div className={"display-flex position-relative"}>
                        <div className="container user-img-parallax " style={{ position: "relative" }}>
                            {/* Profile image background if any */}
                            <div className="display-flex" style={{ justifyContent: "center" }} />
                        </div>

                        <div className={"display-flex container-user-pp"}>
                            <div
                                className={"user-pp"}
                                style={{
                                    border: "4px solid white",
                                    borderRadius: "50%",
                                    height: 100,
                                    width: 100,
                                    overflow: "hidden",
                                    position: "absolute",
                                }}
                            >
                                <img
                                    src={`https://x.solution-digitale.ch/assets/users/${username}.png`}
                                    alt={username}
                                    onError={(e) => {
                                        e.currentTarget.src = "https://x.solution-digitale.ch/assets/users/sd.png";
                                    }}
                                    height={100}
                                    width={100}
                                    style={{ objectFit: "cover", background: "azure" }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={"display-flex position-relative mb-20 flex-direction-column"}>
                        <h3 className={"color-third text-center mt-20"}>
                            {loading && !user ? "Chargement…" : `${firstname} ${lastname}`.trim()}
                        </h3>
                        <div className={"container-user-infos display-flex justify-content-center gap-20 mt-10"}>
              <span className={"display-flex gap-10 align-items-center"}>
                <i className="fa-regular fa-toolbox"></i> {role} |{" "}
                  <i className="fa-regular fa-envelope"></i> {email}
              </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserData;
